"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const positioning_1 = require("../../../helpers/positioning");
const useFadeInOut_1 = require("../../../hooks/useFadeInOut");
const getTooltipOffsetX = (ref) => {
    if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const margins = (0, positioning_1.getOffsetX)(rect, ref.current.offsetWidth, document.body.offsetWidth);
        return (0, positioning_1.collapseBox)(margins);
    }
    else {
        return `0px 0px 0px 0px`;
    }
};
// needs more work so tooltip doesn't overflow outside page
const Tooltip = ({ children, content, className, position = 'top', testing }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const { display, animateIn } = (0, useFadeInOut_1.useFadeInOut)(showTooltip);
    const tooltipRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("span", { onMouseEnter: () => setShowTooltip(true), onMouseLeave: () => setShowTooltip(false), className: (0, classnames_1.default)('relative', className) },
        children,
        display && (react_1.default.createElement("div", { ref: tooltipRef, className: (0, classnames_1.default)('absolute left-1/2 my-2 flex w-[300px] -translate-x-1/2 items-end justify-center transition-opacity', position === 'top' ? 'bottom-full' : 'top-full', animateIn ? 'opacity-100' : 'opacity-0'), "data-testid": testing && 'tooltip-container' },
            react_1.default.createElement("div", { className: "relative rounded bg-black bg-opacity-75 px-2 py-1 text-sm text-white", style: { margin: getTooltipOffsetX(tooltipRef) } }, content),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('absolute left-1/2 w-4 -translate-x-1/2 overflow-hidden px-1', position === 'top' ? 'top-full' : 'bottom-full'), "data-testid": testing && 'tooltip-arrow-container' },
                react_1.default.createElement("div", { className: `h-2 w-2  rotate-45 bg-black bg-opacity-75 ${position === 'top' ? '-translate-y-1/2' : 'translate-y-1/2'}`, "data-testid": testing && 'tooltip-arrow' }))))));
};
exports.Tooltip = Tooltip;
